// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__LNv78","inputWrap":"CustomTip_inputWrap__2rVkb"};